export const WORKING_PROCESS_INITIALIZE = "[WORKING_PROCESSES] Initialize";
export const WORKING_PROCESS_STARTED = "[WORKING_PROCESSES] Started";
export const WORKING_PROCESS_COMPLETED = "[WORKING_PROCESSES] Completed";

export const WORKING_PROCESS_GET = "[WORKING_PROCESSES] Get";
export const WORKING_PROCESS_GET_SUCCESS = "[WORKING_PROCESSES] Success";
export const WORKING_PROCESS_GET_FAIL = "[WORKING_PROCESSES] Fail";
